import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
declare var $ : any;

@Component({
  selector: 'app-ordertracking',
  templateUrl: './ordertracking.component.html',
  styleUrls: ['./ordertracking.component.css']
})
export class OrderTrackingComponent implements OnInit {

  constructor(private router : Router) { ;  }

  ngOnInit() {
  }

  OnSubmit(trackingNumbers){
    let shipperId = $("input[name='shipper']:checked").val();
    let url = "";
    switch(shipperId)
    {
      case "1" :
        // alert("DHL");
        // url="http://track.dhl-usa.com/TrackByNbr.asp?ShipmentNumber="; //DHL no longer uses this URL...
        url="http://www.dhl.com/en/express/tracking.html?AWB=";
        break;
      case "2" : 
        // alert("FedEx");
        url = "http://www.fedex.com/Tracking?tracknumbers=";
        break;
    }
    
    url += encodeURIComponent(trackingNumbers);;
    window.open(url);
  }
}
/*
http://www.fedex.com/us/developer/faqs.html
https://www.fedex.com/us/developer/web-services/index.html
https://www.fedex.com/us/developer/WebHelp/ws/2015/html/WebServicesHelp/WSDVG/Appendix_AA__L6_Mock_Tracking_Numbers.htm
https://www.fedex.com/us/developer/WebHelp/ws/2017/html/WebServicesHelp/WSDVG_US_CA/wsdvg/Appendix_F_Test_Server_Mock_Tracking_Numbers.htm

Tracking Number			Scan Event
449044304137821			Shipment information sent to FedEx
149331877648230			Tendered 
20207021381215			Picked Up
403934084723025			Arrived at FedEx location
920241085725456			At local FedEx facility
568838414941			  At destination sort facility
39813852990618			Departed FedEx location
231300687629630			On FedEx vehicle for delivery
797806677146			  International shipment release
377101283611590			Customer not available or business closed (Delivery Exception 007)
852426136339213			Local Delivery Restriction (Delivery Exception 083)
797615467620			  Incorrect Address (Delivery Exception 03)
957794015041323			Unable to Deliver (Shipment Exception 099)
76288115212522		  Returned to Sender/Shipper
581190049992			  Clearance delay (International)
122816215025810			Delivered
843119172384577			Hold at Location
70358180009382			Shipment Canceled

*/